export const ConfigApi = {
  // ? 'http://177.73.170.254:3333'
  port: process.env.NODE_ENV === 'development' ? '3333' : '4952',
  baseURL: '', // prrencher caso queira que seja um endereço diferente do servidor web
  // URLs
  contabilidadeURL: 'contabilidades',
  municipioURL: 'municipios',
  grupoURL: 'grupos',
  empresaURL: 'empresas',
  formaPagamentoURL: 'formasPagamento',
  enderecoURL: 'enderecos',
  mapsURL: 'maps',
  pedidoURL: 'pedidos',
  usuarioURL: 'usuarios',
  apiInfoURL: 'apiInfo',
  produtoGrupoURL: 'produtoGrupos',
  produtoURL: 'produtos',
  ProdutoUnidadeURL: 'produtoUnidades',
};

export const ListaTiposServicos = [
  { value: 0, label: 'Entrega' },
  { value: 1, label: 'Retirada Balcão' },
  { value: 2, label: 'Consumo no Local' },
];

export const cfgPtBr = {
  firstDayOfWeek: 0,
  dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  dayNamesMin: ['Do', 'Seg', 'Te', 'Qua', 'Qui', 'Sex', 'Sa'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  monthNamesShort: [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez',
  ],
  today: 'Hoje',
  clear: 'Limpa',
};

export const listaUfs = [
  { label: 'AC', value: 'AC' },
  { label: 'AL', value: 'AL' },
  { label: 'AP', value: 'AP' },
  { label: 'AM', value: 'AM' },
  { label: 'BA', value: 'BA' },
  { label: 'CE', value: 'CE' },
  { label: 'DF', value: 'DF' },
  { label: 'ES', value: 'ES' },
  { label: 'GO', value: 'GO' },
  { label: 'MA', value: 'MA' },
  { label: 'MT', value: 'MT' },
  { label: 'MS', value: 'MS' },
  { label: 'MG', value: 'MG' },
  { label: 'PA', value: 'PA' },
  { label: 'PB', value: 'PB' },
  { label: 'PR', value: 'PR' },
  { label: 'PE', value: 'PE' },
  { label: 'PI', value: 'PI' },
  { label: 'RJ', value: 'RJ' },
  { label: 'RN', value: 'RN' },
  { label: 'RS', value: 'RS' },
  { label: 'RO', value: 'RO' },
  { label: 'RR', value: 'RR' },
  { label: 'SC', value: 'SC' },
  { label: 'SP', value: 'SP' },
  { label: 'SE', value: 'SE' },
  { label: 'TO', value: 'TO' },
];
